import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../../jsonapi-provider';
import { LocalDate } from '../../utils/local-date';
import Customer from '../customer';
import type Invoice from './invoice';

@JsonApiResource({
  type: 'customer-month-invoice',
})
export default class CustomerMonthInvoice extends BaseEntity {
  @JsonApiProperty({ resolver: (val: any) => new LocalDate(val) })
  public startDate: LocalDate;

  @JsonApiProperty({ resolver: (val: any) => new LocalDate(val) })
  public endDate: LocalDate;

  @JsonApiRelationship('invoice')
  public invoices: Invoice[];

  @JsonApiRelationship('customer')
  public customer: Customer;

  @JsonApiProperty({ resolver: Number }) public totalPrice: number = 0.0;

  @JsonApiProperty({ resolver: Number }) public totalPriceWithTaxes: number = 0.0;

  constructor(
    id?: BaseEntity['id'],
    startDate: LocalDate = new LocalDate().startOf('month'),
    endDate: LocalDate = new LocalDate().endOf('month'),
    totalPrice: number = 0.0,
    totalPriceWithTaxes: number = 0.0,
    invoices: CustomerMonthInvoice['invoices'] = [],
    customer: CustomerMonthInvoice['customer'] = new Customer()
  ) {
    super();
    this.id = id;
    this.startDate = startDate;
    this.endDate = endDate;
    this.invoices = invoices;
    this.customer = customer;
    this.totalPrice = totalPrice;
    this.totalPriceWithTaxes = totalPriceWithTaxes;
  }
}
